import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	OnChanges,
	Output,
	SimpleChange,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { MatLegacyMenuTrigger as MatMenuTrigger } from "@angular/material/legacy-menu";
import { coerceBoolean } from "@obg/ngx.global.evo";

@Component({
	selector: "obg-m-dropdown-menu",
	templateUrl: "./dropdown-menu.component.html",
	styleUrls: ["./dropdown-menu.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DropdownMenuComponent implements OnChanges {
	@HostBinding("class.obg-m-dropdown-menu") hostCssClass = true;

	@Input() width = "230px";
	@Input() backdropClass: string | undefined;
	@Input() panelClass: string | undefined;

	@Input()
	@coerceBoolean()
	autoClose = false;

	@Output() opened = new EventEmitter<boolean>();

	matMenuPanelClass: string | undefined;
	private readonly baseMatMenuPanelClass = "obg-m-dropdown-menu-panel";

	@ViewChild(MatMenuTrigger, { static: true }) private trigger: MatMenuTrigger | undefined;

	constructor() {
		this.matMenuPanelClass = this.baseMatMenuPanelClass;
	}

	ngOnChanges(changes: { panelClass: SimpleChange }) {
		if (!changes.panelClass) {
			return;
		}

		this.matMenuPanelClass = this.panelClass
			? `${this.baseMatMenuPanelClass} ${this.panelClass}`
			: this.baseMatMenuPanelClass;
	}

	handleClick(event: Event) {
		if (!this.autoClose) {
			event.stopPropagation();
		}
	}

	openMenu() {
		if (this.trigger) {
			this.trigger.openMenu();
		}
	}

	closeMenu() {
		if (this.trigger) {
			this.trigger.closeMenu();
		}
	}

	get isActive(): boolean | undefined {
		return this.trigger ? this.trigger.menuOpen : undefined;
	}
}
